<div class="page-wrapper view-wrapper">

  <div class="page-inner site-wrapper">

    <div id="site-content" class="page-content-wrapper wrapper site-content">

      <main id="maincontent"
        class="page-content container-fluid p-0 mobile-padding category-{{category ? category : 'default'}}">
        <div [class]="containerClass">
          <router-outlet></router-outlet>
          @if (isPrintPDFRoute) {
            <core-pdf-back-page></core-pdf-back-page>
          }
        </div>

      </main>

      <core-footer></core-footer>

      <core-floating-footer></core-floating-footer>
    </div>

    <core-fab-shortcut></core-fab-shortcut>
  </div>
</div>
